// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-offset[data-v-33e6d76f]{top:4rem}.sticky-top[data-v-33e6d76f]{z-index:1}.card[data-v-33e6d76f]{border-top:none;border-radius:0rem 0rem .25rem .25rem}table[data-v-33e6d76f]{border-collapse:separate;border-spacing:0}thead tr th[data-v-33e6d76f]{border:none}", ""]);
// Exports
module.exports = exports;
